import { useEffect, useRef } from 'react';

export default function CursorGlow() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    let x = -1000, y = -1000;
    let cx = -1000, cy = -1000;
    let raf;

    const onMove = (e) => { x = e.clientX; y = e.clientY; };
    window.addEventListener('mousemove', onMove);

    function animate() {
      cx += (x - cx) * 0.06;
      cy += (y - cy) * 0.06;
      el.style.left = cx + 'px';
      el.style.top = cy + 'px';
      raf = requestAnimationFrame(animate);
    }
    animate();

    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return <div ref={ref} className="cursor-glow" />;
}
